/* Informational only: never changes cart, discounts, inventory or checkout. */
(() => {
  if (customElements.get('cybernut-gift-estimate')) return;
  const money = cents => new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(Math.ceil(cents / 100));
  class CybernutGiftEstimate extends HTMLElement {
    connectedCallback() {
      try { this.config = JSON.parse(this.querySelector('[data-cn-config]').textContent); } catch (_) { return; }
      this.subtotal = Number(this.dataset.subtotal);
      this.currency = this.dataset.currency;
      this.render();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          if (event.cartData && Number.isFinite(event.cartData.total_price)) {
            this.subtotal = event.cartData.total_price;
            this.currency = event.cartData.currency || this.currency;
            this.render();
          }
        });
      }
      this.onVisibility = () => { if (!document.hidden) this.render(); };
      document.addEventListener('visibilitychange', this.onVisibility);
      // Only update the calendar state; no polling the server.
      this.timer = setInterval(() => this.render(), 60000);
    }
    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
    render() {
      const message = this.querySelector('[data-cn-message]');
      const label = this.querySelector('[data-cn-label]');
      const progress = this.querySelector('[data-cn-progress]');
      if (!message || !label || !progress || !this.config) return;
      const now = Date.now();
      const start = Date.parse(this.config.start), end = Date.parse(this.config.end);
      progress.hidden = true;
      if (now < start) {
        label.textContent = '8–11 OCT';
        message.textContent = 'La promoción empieza el 8 de octubre a las 00:00, hora de Chile. Tu compra actual aún no participa.';
        return;
      }
      if (now >= end) {
        label.textContent = 'FINALIZADO';
        message.textContent = 'AfterNuts terminó. Los pedidos realizados durante la vigencia conservan su evaluación de regalo al confirmar el pago.';
        return;
      }
      if (this.currency !== 'CLP' || !Number.isSafeInteger(this.subtotal) || this.subtotal < 0) {
        label.textContent = 'VER CONDICIONES';
        message.textContent = 'Tu regalo se determina según el subtotal final en pesos chilenos después de descuentos.';
        return;
      }
      progress.hidden = false;
      progress.value = Math.min(this.subtotal, 5000100);
      label.textContent = 'ESTIMADO';
      if (this.subtotal > 5000000) {
        message.textContent = this.config.available450 === true
          ? 'Tu carrito alcanza Choco Maní 450 g + ebook de 100 recetas de regalo. El frasco de 450 g reemplaza al de 200 g.'
          : 'Tu carrito alcanza el tramo de 450 g, pero el regalo no tiene stock disponible. No se asignará otro formato automáticamente.';
      } else if (this.subtotal > 4000000) {
        message.textContent = this.config.available200 === true
          ? (this.config.available450 === true
            ? `Tu carrito alcanza Choco Maní 200 g. Agrega ${money(5000100 - this.subtotal)} para superar $50.000 y llevar 450 g + ebook de 100 recetas.`
            : 'Tu carrito alcanza Choco Maní 200 g. El regalo de 450 g está sin stock por ahora.')
          : 'Tu carrito alcanza el tramo de 200 g, pero el regalo no tiene stock disponible.';
      } else {
        message.textContent = `Agrega ${money(4000100 - this.subtotal)} para superar $40.000 y alcanzar Choco Maní 200 g de regalo.`;
      }
    }
  }
  customElements.define('cybernut-gift-estimate', CybernutGiftEstimate);
})();
